import { ImmutableList, ImmutableMap } from 'src/modules/Immutable';

export const US_STATE_ABBREVIATIONS = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
} as const;

export type USStateAbbreviation = keyof typeof US_STATE_ABBREVIATIONS;
export type USState = (typeof US_STATE_ABBREVIATIONS)[USStateAbbreviation];

type USStateOptions =
  | { label: USState; value: USStateAbbreviation }
  | { label: 'Everywhere'; value: undefined };

type USAbbreviationStateOptions =
  | { label: USStateAbbreviation; value: USStateAbbreviation }
  | { label: '-'; value: undefined };

const BASE_US_STATE_OPTIONS: ImmutableList<USStateOptions> = ImmutableList<
  [USStateAbbreviation, USState]
>(ImmutableMap<USStateAbbreviation, USState>(US_STATE_ABBREVIATIONS))
  .map(([abbreviation, state]) => ({ label: state, value: abbreviation }))
  .sortBy(({ label }) => label.toLocaleLowerCase());

export const US_STATE_OPTIONS: ImmutableList<USStateOptions> = BASE_US_STATE_OPTIONS.unshift({
  label: 'Everywhere',
  value: undefined,
});

const BASE_US_STATE_ABBREVIATED_OPTIONS: ImmutableList<USAbbreviationStateOptions> =
  ImmutableList<USStateAbbreviation>(
    ImmutableMap<USStateAbbreviation, USState>(US_STATE_ABBREVIATIONS).keys(),
  )
    .map((abbreviation) => ({ label: abbreviation, value: abbreviation }))
    .sortBy(({ label }) => label.toLocaleLowerCase());

export const US_STATE_ABBREVIATED_OPTIONS: ImmutableList<USAbbreviationStateOptions> =
  BASE_US_STATE_ABBREVIATED_OPTIONS.unshift({
    label: '-',
    value: undefined,
  });
